/* #150 combined PDP buy box (v2): interactions and basket add. Loaded with assets/dpc-buybox-core.js on v2
   product pages only (layout/theme.liquid). Markup: snippets/dpc-buybox.liquid.

   - Variant rows click Prestige's hidden native radios (legend + label match, as setVariantByOption in
     cats-atelier-pdp.js), so Prestige keeps running the URL, gallery, payment terms and the form's id.
   - Property rows are real required inputs on the cart form (form="..."), so they post with or without JS.
   - One record per axis (T-650): a variant-backed choice never writes a line-item property.
   - Single-line adds submit the real form (Prestige's own submit handler). With the step add-on, the shelf
     and the step are posted to /cart/add.js one after the other (shelf first), so a failed step line
     never takes the shelf with it, and a second tap posts only the lines that failed.
   - DOM events for analytics: dpc:choice, dpc:complete, dpc:blocked, dpc:addresult, dpc:preset, dpc:addon,
     dpc:media. Each is dispatched after the UI has updated, in a setTimeout(0). analytics() at the end of the file
     turns them into GA4 and Clarity calls (Task 6). */
(function () {
  'use strict';

  function init() {
    var box = document.querySelector('.dpc-buybox[data-pdp-layout="v2"]');
    var core = window.DPCBuybox;
    var dataEl = document.getElementById('dpc-buybox-data');
    if (!box || !core || !dataEl || box.dataset.bbReady === '1') return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var rows = data.rows || [];
    var formId = box.getAttribute('data-form-id');
    var state = {};
    var presetUsed = false;
    var minPrice = data.variants.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
    var anyAvailable = data.variants.some(function (v) { return v.available; });

    var el = {
      price: box.querySelector('[data-bb-price]'),
      total: box.querySelector('[data-bb-total]'),
      summary: box.querySelector('[data-bb-summary]'),
      cta: box.querySelector('[data-bb-cta]'),
      ctaText: box.querySelector('[data-bb-cta-text]'),
      error: box.querySelector('[data-bb-error]'),
      same: box.querySelector('[data-bb-same]'),
      preset: box.querySelector('[data-bb-preset]'),
      addon: box.querySelector('[data-bb-addon]'),
      addonCfg: box.querySelector('[data-bb-addon-cfg]'),
      qtyVal: box.querySelector('[data-bb-qty-val]'),
      addonDone: box.querySelector('[data-bb-addon-done]'),
      addonDoneText: box.querySelector('[data-bb-addon-done-text]')
    };

    var addon = data.addon;
    var addonQty = 0;
    var addonState = {};
    var addonEditing = false;
    var addonGroups = el.addon ? Array.prototype.slice.call(el.addon.querySelectorAll('[data-addon-row]')) : [];
    // Lines already in the basket from an attempt that partly failed; a retry posts only the rest.
    var pending = null;
    // A shelf + step add is running: the button stays disabled whatever re-renders meanwhile (final review I-1: a
    // variant:change landing mid-add re-enabled it and a second tap posted the shelf twice).
    var busy = false;

    function cartForm() { return document.getElementById(formId); }
    function rowEl(name) { return box.querySelector('.dpc-bb-row[data-row-name="' + name + '"]'); }
    function rowSpec(name) { for (var i = 0; i < rows.length; i++) if (rows[i].name === name) return rows[i]; return null; }
    // The photo for a choice. On a #94 wall set it is the component shelf's own colour photo (data.set_photos).
    var lastCushion = null;   // the set cushion row changed last: a wood finish photo shows that shelf's cushion
    document.addEventListener('dpc:choice', function (e) { var n = (e.detail || {}).rowName; if (/^shelf_\d+_upper_fabric$/.test(n || '')) lastCushion = n; });
    function photo(name, value) { return core.photoFor(data.variants, data.images, rowSpec(name), value, null, data.set_photos, state, lastCushion); }
    // "Shown: Beige cushion" / "Shown: Wenge wood" (set rows are shelf_N_upper_fabric, shelf_1_wood_finish).
    function shownLabel(name, value) {
      return 'Shown: ' + value + (/upper_fabric$/.test(name) ? ' cushion' : /wood_finish$/.test(name) ? ' wood' : '');
    }
    function money(pence) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(pence / 100);
    }
    function emit(type, detail) {
      setTimeout(function () { document.dispatchEvent(new CustomEvent(type, { detail: detail })); }, 0);
    }
    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // ---- Prestige's hidden native picker ----
    function nativeInput(axis, value) {
      var lcAxis = String(axis).replace(/:/g, '').toLowerCase().trim();
      var lcVal = String(value).toLowerCase().trim();
      var sets = document.querySelectorAll('variant-picker .variant-picker__option');
      for (var f = 0; f < sets.length; f++) {
        var lg = sets[f].querySelector('legend');
        if (!lg || lg.textContent.replace(/:/g, '').toLowerCase().trim() !== lcAxis) continue;
        var labels = sets[f].querySelectorAll('label');
        for (var i = 0; i < labels.length; i++) {
          var sr = labels[i].querySelector('.sr-only');
          if ((sr ? sr.textContent : labels[i].textContent).toLowerCase().trim() === lcVal) {
            return document.getElementById(labels[i].getAttribute('for'));
          }
        }
      }
      return null;
    }
    // silent: mark the radio without a change event (the preset sets several axes, then clicks the last). When the
    // last one is already checked a click fires no change, so Prestige would keep the old variant after the silent
    // axes moved (review 4, B1: the hammock preset posted Grey while showing Cream): send the change ourselves.
    function setNative(axis, value, silent) {
      var input = nativeInput(axis, value);
      if (!input) return false;
      if (input.checked) {
        if (!silent) input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      if (silent) input.checked = true; else input.click();
      return true;
    }

    // Prestige's variant switch costs 110-230 ms on a 4x-throttled phone (it fetches and re-renders its blocks and
    // slides the gallery; #150 Task 7 profile), and run after every tap it landed on the next one. It now runs once
    // the shopper pauses (Martin 2026-10-22), as ONE switch: every queued axis is marked silently, then the last
    // one sends the change. A tap itself only moves the form, the pay-in-3 widget and the link (formNow).
    var PAUSE_MS = 800;
    var nativeQueue = [];
    var nativeTimer = 0;
    function queueNative(axis, value, silent) {
      nativeQueue.push([axis, value, silent]);
      clearTimeout(nativeTimer);
      nativeTimer = setTimeout(function () {
        nativeTimer = 0;
        if (window.requestIdleCallback) requestIdleCallback(flushNative, { timeout: 400 });
        else flushNative();
      }, PAUSE_MS);
    }
    function flushNative() {
      clearTimeout(nativeTimer);
      nativeTimer = 0;
      var q = nativeQueue;
      nativeQueue = [];
      if (!q.length) return;
      var last = q[q.length - 1];
      // Every answer on screen, not only the queued ones: a late Prestige response can have moved its picker to an
      // older variant (final review I-2), and this switch puts it back.
      rows.forEach(function (r) {
        if (r.kind === 'variant' && r.axis && state[r.name] && r.axis !== last[0]) setNative(r.axis, state[r.name], true);
      });
      setNative(last[0], last[1], last[2]);
    }
    // The form holds the variant the answers make, the pay-in-3 widget hears a change on the form's id (as when
    // Prestige moves it) and the link carries ?variant=, so a reload or a shared link keeps the choice.
    function formNow() {
      if (!rows.some(function (r) { return r.kind === 'variant'; })) return;
      var v = currentVariant();
      var id = cartForm() && cartForm().querySelector('input[name="id"]');
      if (!v || !id || +id.value === v.id) return;
      id.value = v.id;
      id.dispatchEvent(new Event('change', { bubbles: true }));
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    // Before anything can add: Prestige's queued switch runs now and the form holds the variant on screen.
    function syncForm() {
      flushNative();
      formNow();
    }

    // ---- state and display ----
    function addonVariant() {
      if (!addon) return null;
      var best = null;
      addon.variants.forEach(function (v) {
        var ok = addonGroups.every(function (g) {
          var name = g.getAttribute('data-addon-row');
          return !addonState[name] || v.options[+g.getAttribute('data-option-index')] === addonState[name];
        });
        if (ok && (!best || v.price < best.price)) best = v;
      });
      return best;
    }
    function addonOpen() {
      if (!addonQty) return [];
      return addonGroups.filter(function (g) { return !addonState[g.getAttribute('data-addon-row')]; })
        .map(function (g) { return 'steps_' + g.getAttribute('data-addon-row'); });
    }
    function openList() { return core.openRows(rows, state).concat(addonOpen()); }
    function currentVariant() {
      if (!rows.some(function (r) { return r.kind === 'variant'; })) {
        var form = cartForm();
        var id = form && form.querySelector('input[name="id"]');
        var vid = id ? +id.value : data.variants[0].id;
        for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === vid) return data.variants[i];
        return data.variants[0];
      }
      return core.matchVariant(data.variants, rows, state);
    }

    // "Same as the cushion" pairs the cushion row with the base row: base_fabric/upper_fabric on a shelf page,
    // shelf_1_base_fabric/shelf_1_upper_fabric on the one-shelf wall sets (#150).
    function samePair() {
      if (rowSpec('base_fabric') && rowSpec('upper_fabric')) return ['upper_fabric', 'base_fabric'];
      if (rowSpec('shelf_1_base_fabric') && rowSpec('shelf_1_upper_fabric')) return ['shelf_1_upper_fabric', 'shelf_1_base_fabric'];
      return null;
    }
    // #150: wall-set cushion rows shelf_2..N follow shelf_1 while the "Same cushion on both shelves" box is ticked.
    var sameAll = box.querySelector('[data-bb-sameall]');
    var sameIn = sameAll && sameAll.querySelector('input');
    var followers = rows.filter(function (r) { return /^shelf_([2-9]|\d\d+)_upper_fabric$/.test(r.name); })
                        .map(function (r) { return r.name; });
    var linked = false;   // decided after the page-load answers are read

    function setRowUI(name) {
      var r = rowEl(name);
      if (!r) return;
      var v = state[name];
      var shown = r.querySelector('[data-bb-rowv]');
      shown.textContent = v || 'Choose';
      if (linked && v && followers.indexOf(name) >= 0) shown.textContent = v + ' (same as shelf 1)';
      shown.classList.toggle('is-need', !v);
      r.querySelector('.dpc-bb-num').classList.toggle('is-done', !!v);
      var inputs = r.querySelectorAll('.dpc-bb-input');
      for (var i = 0; i < inputs.length; i++) if (inputs[i].value === v && !inputs[i].checked) inputs[i].checked = true;
      var sel = r.querySelector('select.dpc-bb-select');
      if (sel && v && sel.value !== v) sel.value = v;
      var nx = r.querySelector('[data-bb-next]');
      if (nx) nx.hidden = !v;
    }
    // The question a colour row's Next button goes to: the first unanswered row after it, else the total.
    function nextLabels() {
      var all = Array.prototype.slice.call(box.querySelectorAll('.dpc-bb-row'));
      all.forEach(function (r, i) {
        var nx = r.querySelector('[data-bb-next]');
        if (!nx) return;
        var label = 'Done';
        for (var j = i + 1; j < all.length; j++) {
          var nm = all[j].getAttribute('data-row-name');
          if (!state[nm]) { label = 'Next: ' + (rowSpec(nm).label || nm); break; }
        }
        nx.textContent = label;
      });
    }

    function refresh() {
      var v = currentVariant();
      var av = addonVariant();
      // Until every option is answered: the cheapest variant that fits what is chosen, so the price follows the size
      // straight away (review 4, F1: 95cm showed the 75cm price until the cushion was picked).
      var fit = v ? null : core.fromPrice(data.variants, rows, state);
      var base = v ? v.price : fit ? fit.price : minPrice;
      if (el.price) el.price.textContent = money(base);
      var from = box.querySelector('.dpc-bb-from');
      if (from) from.hidden = !!v || (!!fit && !fit.varies);
      if (el.total) el.total.textContent = money(core.totalPence({ price: base }, { variant: av, qty: addonQty }));
      if (el.qtyVal) el.qtyVal.textContent = String(addonQty);
      // Once the step colours are chosen they fold to one line (Martin 2026-10-21); Change opens them again.
      var folded = addonQty > 0 && addonGroups.length > 0 && !addonOpen().length && !addonEditing;
      if (el.addonCfg) el.addonCfg.hidden = addonQty === 0 || folded;
      if (el.addonDone) {
        el.addonDone.hidden = !folded;
        if (folded) el.addonDoneText.textContent = addonQty + (addonQty === 1 ? ' step' : ' steps') + ' · ' + addonGroups.map(function (g) {
          return addonState[g.getAttribute('data-addon-row')] + ' ' + (g.getAttribute('data-addon-label') || '');
        }).join(' · ');
      }
      if (el.same) {
        var sp = samePair();
        el.same.disabled = !sp || !state[sp[0]];
        el.same.setAttribute('aria-pressed', sp && state[sp[0]] && state[sp[1]] === state[sp[0]] ? 'true' : 'false');
      }
      var soldOut = !anyAvailable || (v && !v.available);
      // Every option answered but no such variant (MiaCara Desco has 6 missing combinations): never addable (B5).
      var variantRows = rows.filter(function (r) { return r.kind === 'variant'; });
      var noSuch = !v && variantRows.length > 0 && variantRows.every(function (r) { return state[r.name]; });
      var ctaLabel = noSuch ? 'Unavailable' : soldOut ? 'Sold out' : 'Add to basket';
      if (el.cta) {
        el.cta.disabled = busy || !!soldOut || noSuch;
        el.ctaText.textContent = ctaLabel;
      }
      var left = openList();
      if (el.summary) {
        var picked = rows.filter(function (r) { return state[r.name]; }).map(function (r) { return state[r.name]; });
        el.summary.textContent = left.length
          ? (left.length === 1 ? '1 choice left' : left.length + ' choices left')
          : picked.join(' · ');
      }
      setExpressCover(left.length > 0 || noSuch);
      setExpressHidden(addonQty > 0);
      markOptions();
      nextLabels();
      syncBar();
      if (card) {
        card.choices.textContent = el.summary ? el.summary.textContent : '';
        card.total.textContent = el.total ? el.total.textContent : '';
        card.cta.disabled = busy || !!soldOut || noSuch;
        // "Add to basket" with choices open too, as the phone bar (Martin 2026-10-22, F12): a tap goes to the open one.
        card.cta.textContent = ctaLabel;
      }
    }

    // Desktop summary card (main-product.liquid, the right column beside the content below the gallery): Martin's
    // desktop review 2026-10-21, so the choices and Add to basket stay in reach while reading. It mirrors the buy box
    // and its button goes through the buy box's own CTA, so there is one add path.
    var cardEl = document.querySelector('[data-bb-card]');
    var card = cardEl && {
      choices: cardEl.querySelector('[data-bb-card-choices]'),
      total: cardEl.querySelector('[data-bb-card-total]'),
      cta: cardEl.querySelector('[data-bb-card-cta]'),
      change: cardEl.querySelector('[data-bb-card-change]')
    };
    // One add path for the card and the phone's bottom bar: blocked with a message when a choice is missing, else the
    // buy box's own button (shelf + step when a step is added).
    function addFrom(location) {
      if (openList().length) block(location);
      else if (el.cta) el.cta.click();
    }
    // Never two Add to basket buttons on screen (Martin 2026-10-21): the desktop card, and the bottom bar on tablets
    // (2026-10-22, F13), show once the buy box's own button has scrolled off the top. A scroll check, not an
    // IntersectionObserver: a jump from above the button straight past it (a link, a fast fling) never crosses the
    // viewport, so an observer would never fire.
    var pastTick = 0;
    var pastCheck = function () {
      pastTick = 0;
      // Phones keep their own bar rule (dpc-sticky-atc.js); no layout read there.
      var past = window.innerWidth >= 700 && !!el.cta && el.cta.getBoundingClientRect().bottom < 0;
      document.body.classList.toggle('dpc-bb-cta-past', past);
      document.body.classList.toggle('dpc-bb-card-on', !!card && past && window.innerWidth >= 1000);
    };
    var pastQueue = function () { if (!pastTick) pastTick = requestAnimationFrame(pastCheck); };
    window.addEventListener('scroll', pastQueue, { passive: true });
    window.addEventListener('resize', pastQueue, { passive: true });
    pastCheck();
    if (card) {
      card.cta.addEventListener('click', function () { addFrom('card'); });
      // Scrolling up brings Prestige's header back, so the choices land below it (scroll-margin read the header's
      // height while it was hidden: review 4, F5); focus goes with them.
      card.change.addEventListener('click', function () {
        var ch = box.querySelector('[data-bb-choices]') || box;
        var hh = hdr ? hdr.offsetHeight : 0;
        window.scrollTo({ top: Math.max(0, ch.getBoundingClientRect().top + window.scrollY - hh - 20), behavior: reducedMotion() ? 'auto' : 'smooth' });
        var openRow = openList().map(rowEl).filter(Boolean)[0] || box.querySelector('.dpc-bb-row');
        var s = openRow && openRow.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      });
    }

    // Options that cannot be bought with the answers so far are greyed with a label, and stay tappable (review 4, F7;
    // Martin 2026-10-22).
    function markOptions() {
      rows.forEach(function (r) {
        if (r.kind !== 'variant') return;
        var st = core.optionStatus(data.variants, rows, state, r.name);
        var re = rowEl(r.name);
        if (!re) return;
        Array.prototype.forEach.call(re.querySelectorAll('.dpc-bb-opt'), function (lab) {
          var input = lab.querySelector('.dpc-bb-input');
          var s = input && st[input.value];
          var text = !s || s.status === 'ok' ? '' : s.status === 'soldout' ? 'Sold out'
            : s.clash ? 'Not available with ' + state[s.clash] : 'Not available';
          lab.classList.toggle('is-unavail', !!text);
          var x = lab.querySelector('.dpc-bb-optx');
          if (!text) { if (x) x.remove(); return; }
          if (!x) {
            x = document.createElement('span');
            x.className = 'dpc-bb-optx';
            lab.querySelector('.dpc-bb-optn').appendChild(x);
          }
          x.textContent = ' · ' + text;
        });
      });
    }

    // A tapped option with no such combination: keep it, and ask again the question that ruled it out.
    function clearClash(name, value) {
      var s = core.optionStatus(data.variants, rows, state, name)[value];
      if (!s || s.status !== 'none' || !s.clash) return null;
      delete state[s.clash];
      delete sources[s.clash];
      var r = rowEl(s.clash);
      if (r) Array.prototype.forEach.call(r.querySelectorAll('.dpc-bb-input'), function (i) { i.checked = false; });
      setRowUI(s.clash);
      return s.clash;
    }

    function choose(name, value, source) {
      var spec = rowSpec(name);
      if (!spec || !value) return;
      var reopen = source === 'tap' ? clearClash(name, value) : null;
      state[name] = value;
      // A changed shelf after a partial add is a new shelf: post it (and the step) again, not the step alone (B2).
      if (pending && source !== 'prefill') pending = null;
      if (spec.kind === 'variant' && spec.axis && source !== 'prefill') {
        queueNative(spec.axis, value, source === 'preset-silent');
        formNow();
      }
      setRowUI(name);
      hideError();
      // A colour tap stays put so colours can be browsed; its Next button moves on (Martin 2026-10-21). Arrow keys
      // move through a radio group choosing as they go, so they never close it (review 4, F4).
      if (reopen) {
        rowEl(name).open = false;
        rowEl(reopen).open = true;
        place(rowEl(reopen), browsable(reopen));
      } else if (source === 'tap' && !browsable(name) && !arrowKey) advanceFrom(name);
      refresh();
      var src = source === 'preset-silent' ? 'preset' : source === 'early' ? 'tap' : source;
      sources[name] = src;
      emit('dpc:choice', { rowName: name, rowIndex: rows.indexOf(spec) + 1, value: value, source: src });
      checkComplete();
      // #150: while linked, a later tap on shelf 1 also chooses the same colour on the other shelves (source 'same'
      // never advances or moves focus); a tap on a later shelf itself means "different colours" and unlinks.
      // Positive tests (design-final corrections 1-2): only a shopper's own tap mirrors or unlinks, so a future source
      // type can never silently do either.
      if (linked && (source === 'tap' || source === 'early')) {
        if (name === 'shelf_1_upper_fabric') {
          if (source === 'tap') followers.forEach(function (f) { if (state[f] !== value) choose(f, value, 'same'); });
        } else if (followers.indexOf(name) >= 0 && value !== state.shelf_1_upper_fabric) {
          setLinked(false);
          // A split by a tap on row 2 is a split too (ga4-conventions.md pdp_set_split); a programmatic untick fires no change.
          emit('dpc:sameall', { on: false });
        }
      }
    }

    function setLinked(on) {
      linked = !!on;
      if (sameIn) sameIn.checked = linked;
      if (linked) followers.forEach(function (f) {
        if (state.shelf_1_upper_fabric && state[f] !== state.shelf_1_upper_fabric) choose(f, state.shelf_1_upper_fabric, 'same');
      });
      followers.forEach(setRowUI);
    }
    if (sameIn) sameIn.addEventListener('change', function () {
      setLinked(sameIn.checked);
      emit('dpc:sameall', { on: sameIn.checked });
    });

    // dpc:complete once per completion (analytics plan pdp_choices_complete): again only after something re-opens
    // (a step added), never on a change to a row already answered.
    var sources = {};
    var completeSent = false;
    function checkComplete() {
      if (openList().length) { completeSent = false; return; }
      if (completeSent) return;
      completeSent = true;
      var kinds = [];
      Object.keys(sources).forEach(function (k) {
        var s = sources[k] === 'same' ? 'tap' : sources[k];
        if (kinds.indexOf(s) < 0) kinds.push(s);
      });
      emit('dpc:complete', { presetUsed: presetUsed, rowsRequired: rows.length + (addonQty > 0 ? addonGroups.length : 0),
        sourceMix: kinds.length === 1 ? (kinds[0] === 'tap' ? 'all_tap' : kinds[0]) : kinds.length ? 'mixed' : 'none' });
    }

    // #94: a wall set's shelf cushion and wood finish rows (shelf_N_*) are colour rows too, photographed from the shelf.
    function isColourRow(name) { return /^(?:shelf_\d+_)?(upper_fabric|base_fabric|colour)$|^shelf_\d+_wood_finish$/.test(name || ''); }
    // A colour row with a photo of its own for every colour (Martin 2026-10-21): only these show the photo, stay open
    // after a tap so colours can be browsed, and have a Next button. Others (Wave base fabric, cat steps) move on
    // by themselves, as Size does.
    var photoRows = {};
    rows.forEach(function (r) { if (isColourRow(r.name) && core.rowHasPhotos(data.variants, data.images, r, data.set_photos)) photoRows[r.name] = true; });
    function browsable(name) { return !!photoRows[name]; }
    Array.prototype.forEach.call(box.querySelectorAll('[data-bb-next]'), function (nx) {
      if (!browsable(nx.closest('.dpc-bb-row').getAttribute('data-row-name'))) nx.remove();
    });
    function advanceFrom(name) {
      var r = rowEl(name);
      var all = Array.prototype.slice.call(box.querySelectorAll('.dpc-bb-row'));
      var i = all.indexOf(r);
      // Keyboard and screen-reader users keep their place: focus follows to the next question (review 4, F4).
      var hadFocus = box.contains(document.activeElement);
      r.open = false;
      for (var j = i + 1; j < all.length; j++) {
        var nm = all[j].getAttribute('data-row-name');
        if (!state[nm]) {
          all[j].open = true;
          place(all[j], browsable(nm));
          if (hadFocus) all[j].querySelector('summary').focus({ preventScroll: true });
          return;
        }
      }
      // Nothing left to answer: bring the add-on (or the total) to the same spot. Placed below the photo when a
      // colour was just picked, so the photo's short linger does not cover it.
      place(el.addon || box.querySelector('.dpc-bb-summary'), browsable(name));
    }

    // ---- the fixed spot (phone): Martin's phone review 2026-10-21 ----
    // After each answer the next question's heading lands 12px below whatever covers the top of the screen: the
    // header, plus the colour photo for a colour question. Prestige hides the header once the page has travelled
    // more than 100px down from where it last scrolled up (theme.js detectScrollDirection_fn, tracking point starts
    // at 0), and shows it again on scrolling up past that point. That rule is mirrored here so the spot is worked
    // out for the header as it will be when the scroll ends, not as it is when it starts.
    var hdr = document.querySelector('header .header');
    // Read once per frame, not per scroll event: during the smooth scroll after an answer each read forced a layout
    // (128-173 ms a tap on a 4x-throttled phone, #150 Task 7 profile).
    var trk = 0, trkFrame = 0;
    window.addEventListener('scroll', function () {
      if (trkFrame) return;
      trkFrame = requestAnimationFrame(function () {
        trkFrame = 0;
        var y = Math.max(0, window.scrollY);
        if (y > trk && y - trk > 100) trk = y;
        else if (y < trk) trk = y;
      });
    }, { passive: true });
    function place(target, belowPhoto) {
      if (!target || window.innerWidth > 749) return;
      var hh = hdr ? hdr.offsetHeight : 0;
      var shown = !(hdr && hdr.classList.contains('is-hidden'));
      var cover = (belowPhoto ? core.pinHeight(window.innerHeight) : 0) + 12;
      var top = target.getBoundingClientRect().top + window.scrollY;
      var y = top - cover - (shown ? hh : 0);
      if (shown && y > window.scrollY && y - trk > 100) y = top - cover;        // header will hide on the way down
      else if (!shown && y < trk) y = top - cover - hh;                          // header will come back on the way up
      y = Math.max(0, Math.round(y));
      if (Math.abs(y - window.scrollY) < 2) return;
      window.scrollTo({ top: y, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }

    function hideError() {
      if (el.error) { el.error.hidden = true; el.error.textContent = ''; el.error.removeAttribute('aria-hidden'); }
      Array.prototype.forEach.call(box.querySelectorAll('[data-bb-rowerr]'), function (m) { m.remove(); });
    }
    function showError(msg) { if (el.error) { el.error.textContent = msg; el.error.hidden = false; } }
    // The blocked message also goes in the question the shopper is taken to: the one by the button was off screen
    // there (review 4, F3). That copy is the announced one; the one by the button stays for sighted shoppers below.
    function rowError(target, msg) {
      var p = document.createElement('p');
      p.className = 'dpc-bb-rowerr';
      p.setAttribute('data-bb-rowerr', '');
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      var s = target.querySelector(':scope > summary');
      if (s) s.insertAdjacentElement('afterend', p); else target.insertBefore(p, target.firstChild);
      if (el.error) el.error.setAttribute('aria-hidden', 'true');
    }

    function block(location) {
      var left = openList();
      var first = left[0];
      var target, label;
      if (first.indexOf('steps_') === 0) {
        var key = first.slice(6);
        target = el.addon && el.addon.querySelector('[data-addon-row="' + key + '"]');
        label = 'the step ' + (key === 'felt' ? 'felt colour' : key === 'platform' ? 'platform colour' : key.replace(/_/g, ' '));
      } else {
        target = rowEl(first);
        if (target) target.open = true;
        label = 'your ' + (rowSpec(first).label || first).toLowerCase();
      }
      hideError();
      showError('Choose ' + label + ' to add this to your basket.');
      if (target) {
        rowError(target, 'Choose ' + label + ' to add this to your basket.');
        target.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
        var focusable = target.querySelector('summary, .dpc-bb-input, select');
        if (focusable) focusable.focus({ preventScroll: true });
      }
      // routedTo 'none' when nothing could be opened: the plan's bug detector (Q7) must be able to fire.
      emit('dpc:blocked', { choicesLeft: left.length, firstOpen: first, routedTo: target ? first : 'none', location: location });
    }

    // ---- express checkout cover (Shopify's dynamic button bypasses our CTA) ----
    function setExpressCover(on) {
      var form = cartForm();
      var btn = form && form.querySelector('.shopify-payment-button');
      if (!btn) return;
      // inert as well as the cover: the cover stops a pointer, but Tab + Enter reached Shop Pay with choices open and
      // started an order without them (review 4, B4).
      if (on) btn.setAttribute('inert', ''); else btn.removeAttribute('inert');
      var cover = btn.querySelector('.dpc-bb-express-cover');
      if (!on) { if (cover) cover.remove(); return; }
      if (cover) return;
      btn.style.position = 'relative';
      cover = document.createElement('div');
      cover.className = 'dpc-bb-express-cover';
      cover.setAttribute('aria-hidden', 'true');
      cover.style.cssText = 'position:absolute;inset:0;z-index:2;cursor:pointer;background:transparent;';
      cover.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        block('express');
      });
      btn.appendChild(cover);
    }

    // Express checkout buys the form's one variant, never the step, so it is hidden while a step is added
    // (Martin 2026-10-22, F11). A Shop Pay button that takes both is a follow-up.
    function setExpressHidden(on) {
      var form = cartForm();
      var btn = form && form.querySelector('.shopify-payment-button');
      if (!btn) return;
      // important: the theme sets display:block !important on .shopify-payment-button.
      if (on) btn.style.setProperty('display', 'none', 'important'); else btn.style.removeProperty('display');
      var note = btn.parentNode.querySelector('[data-bb-express-note]');
      if (!on) { if (note) note.remove(); return; }
      if (note) return;
      note = document.createElement('p');
      note.className = 'dpc-bb-express-note';
      note.setAttribute('data-bb-express-note', '');
      note.textContent = 'Express checkout is not available with steps. Add to basket to buy both.';
      btn.parentNode.insertBefore(note, btn.nextSibling);
    }

    // ---- basket ----
    function shelfItem() {
      var form = cartForm();
      var fd = new FormData(form);
      var item = { id: +fd.get('id'), quantity: +(fd.get('quantity') || 1), properties: {} };
      fd.forEach(function (val, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && val !== '') item.properties[m[1]] = String(val);
      });
      return item;
    }
    function bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      return sections;
    }
    function postLine(item, sections) {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item], sections: sections.join(','), sections_url: location.pathname })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, ok: res.ok, json: json }; });
      }).catch(function (err) { return { status: 0, ok: false, json: { description: String(err) } }; });
    }
    function announceCart(sectionsJson) {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = sectionsJson || {};
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: null, cart: cart }
        }));
      }).catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
    }

    function multiAdd() {
      var av = addonVariant();
      var lines = [];
      if (!pending || !pending.shelf) lines.push({ key: 'shelf', item: shelfItem() });
      if (addonQty > 0 && av && (!pending || !pending.addon)) lines.push({ key: 'addon', item: { id: av.id, quantity: addonQty } });
      if (!lines.length) return;
      var sections = bundledSections();
      var done = pending || {};
      var added = 0, addedValue = 0, lastStatus = 200, lastSections = null, failMsg = '';
      busy = true;
      el.cta.setAttribute('aria-busy', 'true');
      el.cta.disabled = true;
      var chain = Promise.resolve();
      lines.forEach(function (line) {
        chain = chain.then(function () {
          // Never post the step without its shelf.
          if (line.key === 'addon' && !done.shelf) return;
          return postLine(line.item, sections).then(function (r) {
            lastStatus = r.status;
            if (r.ok) {
              done[line.key] = true; added++; lastSections = r.json.sections || lastSections;
              addedValue += line.key === 'addon' ? av.price * addonQty : ((currentVariant() || { price: minPrice }).price * line.item.quantity);
            }
            else failMsg = (r.json && (r.json.description || r.json.message)) || 'Please try again.';
          });
        });
      });
      chain.then(function () {
        busy = false;
        el.cta.removeAttribute('aria-busy');
        refresh();
        var result = core.addResult(lastStatus, lines.length, added);
        if (result === 'ok') { pending = null; hideError(); }
        else {
          pending = done;
          if (done.shelf && !done.addon) {
            showError('Your shelf is in the basket, but the ' + (addon ? addon.title : 'step') + ' could not be added: ' + failMsg + ' Tap Add to basket to try the steps again.');
          } else {
            showError('We could not add this to your basket: ' + failMsg);
          }
        }
        if (added) announceCart(lastSections);
        // value: what actually went in on this tap (a partial add is the shelf alone), not the full total (T4).
        emit('dpc:addresult', { result: result, lines: added, hasAddon: true, presetUsed: presetUsed, value: addedValue });
      });
    }

    // ---- the phone's bottom bar (main-product.liquid) ----
    // Martin 2026-10-21: with a step added it showed the shelf price and its button posted the shelf alone. On v2 it
    // shows the buy box total and its button goes through addFrom. Prestige re-renders the bar on a variant change,
    // so the total is re-applied when its content is replaced.
    function syncBar() {
      if (!el.total) return;
      Array.prototype.forEach.call(document.querySelectorAll('.product-sticky-bar [data-bb-bar-total]'), function (t) {
        if (t.textContent !== el.total.textContent) t.textContent = el.total.textContent;
      });
    }
    // Observe the bar's parent: Prestige replaces the whole <product-rerender> element, which ended an observer on it.
    var barWrap = document.getElementById(formId + '-sticky-bar');
    if (barWrap && barWrap.parentNode && 'MutationObserver' in window) new MutationObserver(syncBar).observe(barWrap.parentNode, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-sticky-bar button[type="submit"]');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addFrom('bar');
    }, true);

    // ---- wiring ----
    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('.dpc-bb-addon input.dpc-bb-input')) {
        var g = t.closest('[data-addon-row]');
        var name = g.getAttribute('data-addon-row');
        addonState[name] = t.value;
        addonEditing = false;
        var shown = g.querySelector('[data-bb-rowv]');
        shown.textContent = t.value; shown.classList.remove('is-need');
        hideError(); refresh();
        sources['steps_' + name] = 'tap';
        emit('dpc:choice', { rowName: 'steps_' + name, rowIndex: rows.length + addonGroups.indexOf(g) + 1, value: t.value, source: 'tap' });
        checkComplete();
        return;
      }
      if (t.matches('.dpc-bb-row .dpc-bb-input, .dpc-bb-row select.dpc-bb-select')) {
        choose(t.closest('.dpc-bb-row').getAttribute('data-row-name'), t.value, 'tap');
      }
    });

    var arrowKey = false;
    box.addEventListener('keydown', function (e) { arrowKey = /^Arrow/.test(e.key) && e.target.matches('.dpc-bb-input'); });
    box.addEventListener('keyup', function () { arrowKey = false; });
    box.addEventListener('pointerdown', function () { arrowKey = false; });

    box.addEventListener('click', function (e) {
      var nx = e.target.closest('[data-bb-next]');
      if (nx) advanceFrom(nx.closest('.dpc-bb-row').getAttribute('data-row-name'));
    });

    if (el.same) el.same.addEventListener('click', function () {
      var sp = samePair();
      if (sp && state[sp[0]]) choose(sp[1], state[sp[0]], 'same');
    });

    if (el.preset && data.preset) el.preset.addEventListener('click', function () {
      presetUsed = true;
      emit('dpc:preset', {});
      var names = Object.keys(data.preset).filter(function (n) { return rowSpec(n); });
      var variantNames = names.filter(function (n) { return rowSpec(n).kind === 'variant'; });
      var lastVariant = variantNames[variantNames.length - 1];
      names.forEach(function (n) {
        var silent = rowSpec(n).kind === 'variant' && n !== lastVariant;
        choose(n, data.preset[n], silent ? 'preset-silent' : 'preset');
      });
      // Leave open only the first row the preset did not answer.
      var opened = false;
      Array.prototype.forEach.call(box.querySelectorAll('.dpc-bb-row'), function (r) {
        var need = !state[r.getAttribute('data-row-name')];
        r.open = need && !opened;
        if (need) opened = true;
      });
    });

    if (el.addon) el.addon.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-addon-change]')) { addonEditing = true; refresh(); emit('dpc:addon', { action: 'open', qty: addonQty }); return; }
      var b = e.target.closest('[data-bb-qty]');
      if (!b) return;
      var was = addonQty;
      addonQty = Math.max(0, Math.min(10, addonQty + (+b.getAttribute('data-bb-qty'))));
      if (addonQty !== was) emit('dpc:addon', { action: !was ? 'add' : !addonQty ? 'remove' : 'qty', qty: addonQty });
      // Steps taken back to 0 after a partial add: the step retry no longer applies, so Add to basket adds again (B3).
      if (!addonQty && pending) { pending = null; hideError(); }
      refresh();
      checkComplete();
    });

    // Every other way to buy (the phone's bottom bar, express checkout, a form submit) syncs first too. Only a press on
    // a buying control does: a press to scroll or on another choice leaves Prestige to the pause.
    document.addEventListener('pointerdown', function (e) {
      if (!nativeQueue.length || !e.target.closest) return;
      if (e.target.closest('buy-buttons, .product-sticky-bar, shopify-accelerated-checkout, .shopify-payment-button, [data-bb-cta], [data-bb-card]')
        || (cartForm() && cartForm().contains(e.target))) syncForm();
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.getAttribute && e.target.getAttribute('id') === formId) syncForm();
    }, true);

    if (el.cta) el.cta.addEventListener('click', function (e) {
      if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      syncForm();
      if (openList().length) { e.preventDefault(); e.stopImmediatePropagation(); block('cta'); return; }
      if (addonQty > 0 || pending) { e.preventDefault(); e.stopImmediatePropagation(); multiAdd(); }
      // else: the button submits the real form and Prestige's product-form adds the single line.
    });

    // A single-line add submitted through Prestige's form.
    document.addEventListener('variant:add', function (e) {
      // getAttribute: the form holds an <input name="id">, so form.id is that input, not the form's id.
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
      emit('dpc:addresult', { result: 'ok', lines: 1, hasAddon: false, presetUsed: presetUsed,
        value: (currentVariant() || { price: minPrice }).price });
    });

    // A single-line add Prestige could not make (sold out, stock): the conventions send result on failure too (T3).
    document.addEventListener('cart:error', function (e) {
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
      emit('dpc:addresult', { result: 'error', lines: 0, hasAddon: false, presetUsed: presetUsed, value: 0 });
    });

    // Prestige re-renders its own blocks on a variant change (never this one): re-sync price, CTA and the
    // express cover, which sits inside the re-rendered buy-buttons block.
    // A late response for an older choice (final review I-2) leaves Prestige on another variant: the form and the
    // link go back to the answers on screen at once, and Prestige's switch runs again at the next pause.
    document.addEventListener('variant:change', function (e) {
      refresh();
      if (e.target !== cartForm()) return;
      var v = currentVariant();
      var dv = e.detail && e.detail.variant;
      if (!v || !dv || dv.id === v.id) return;
      formNow();
      var vrows = rows.filter(function (r) { return r.kind === 'variant' && r.axis && state[r.name]; });
      var lastRow = vrows[vrows.length - 1];
      if (lastRow) queueNative(lastRow.axis, state[lastRow.name], false);
    });

    // Intro "Read more": only shown when the clamp actually hides text.
    var intro = box.querySelector('.dpc-bb-intro__text');
    var more = box.querySelector('.dpc-bb-more');
    if (intro && more) {
      if (intro.scrollHeight > intro.clientHeight + 2) more.hidden = false;
      more.addEventListener('click', function () {
        var open = intro.classList.toggle('dpc-bb-clamp') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Read less' : 'Read more';
      });
    }

    // ---- Option C (phone): the chosen colour's photo, shown while a colour row is open ----
    // Martin's phone review 2026-10-21: the scroll-driven slide looked jumpy, so the photo now fades in only while
    // a colour row (upper_fabric, base_fabric, colour) is open and on screen. CSS places it at
    // var(--sticky-area-height), Prestige's own header offset, so it follows the header when it hides on scroll.
    (function setupPin() {
      var pin = box.querySelector('[data-bb-pin]');
      var main = document.querySelector('main');
      var colourRows = rows.filter(function (r) { return browsable(r.name); })
        .map(function (r) { return rowEl(r.name); }).filter(Boolean);
      if (!pin || !main || !colourRows.length) return;
      main.appendChild(pin);
      var img = pin.querySelector('[data-bb-pin-img]');
      var cap = pin.querySelector('[data-bb-pin-cap]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      var firstImage = data.images && data.images[0] ? data.images[0].src : '';
      var onScreen = {}, hideTimer = 0, userOpen = null;

      // Each photo's shape, for the crop (core.pinCrop: custom.pin_crop when set, else portrait 30% down / centred).
      var ratios = {};
      (data.variants || []).forEach(function (v) { if (v.image) ratios[v.image] = v.ratio; });
      (data.images || []).forEach(function (i) { ratios[i.src] = i.ratio; });
      (data.set_photos || []).forEach(function (p) { ratios[p.src] = p.ratio; });
      function setImage(src) {
        if (!src || img.getAttribute('src') === src) return;
        var crop = core.pinCrop(ratios[src], data.pin_crop);
        img.style.objectFit = crop.fit;
        img.style.objectPosition = crop.pos;
        img.setAttribute('src', src);
      }
      function size() { pin.style.height = core.pinHeight(window.innerHeight) + 'px'; }
      // linger: a colour tap closes its row; keep the photo up a moment so the change is seen.
      function update(linger) {
        var want = window.innerWidth <= 749 && colourRows.some(function (r) { return r.open && onScreen[r.getAttribute('data-row-name')]; });
        clearTimeout(hideTimer);
        pin.style.pointerEvents = '';
        if (want) {
          if (!img.getAttribute('src')) setImage(firstImage);
          pin.setAttribute('data-shown', 'true');
        } else if (linger && pin.getAttribute('data-shown') === 'true') {
          // Lingering over the next question: taps go through to it, not to the photo (review 4, F8).
          pin.style.pointerEvents = 'none';
          hideTimer = setTimeout(function () { pin.setAttribute('data-shown', 'false'); }, 1200);
        } else {
          pin.setAttribute('data-shown', 'false');
        }
      }
      // A colour row the shopper opens by hand goes to the same fixed spot as one opened by an answer.
      colourRows.forEach(function (r) {
        r.querySelector('summary').addEventListener('click', function () { userOpen = r; });
        r.addEventListener('toggle', function () {
          if (r.open && userOpen === r) place(r, true);
          userOpen = null;
          update(!r.open);
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { onScreen[e.target.getAttribute('data-row-name')] = e.isIntersecting; });
          update(false);
        });
        colourRows.forEach(function (r) { io.observe(r); });
      } else {
        colourRows.forEach(function (r) { onScreen[r.getAttribute('data-row-name')] = true; });
      }
      window.addEventListener('resize', function () { size(); update(false); }, { passive: true });

      // The photo follows the latest choice that has one (the colour variant's own image, else an "#Option_Value"
      // alt); a colour without a photo shows the first gallery image (Review Focus 3), never a blank panel.
      document.addEventListener('dpc:choice', function (e) {
        var d = e.detail || {};
        var src = photo(d.rowName, d.value);
        var isColour = browsable(d.rowName);
        if (!isColour) return; // only a photographed colour changes the photo (a Size tap must not)
        if (src) {
          setImage(src);
          cap.textContent = shownLabel(d.rowName, d.value);
        } else if (isColour) {
          setImage(firstImage);
          cap.textContent = '';
        }
      });
      pin.addEventListener('click', function (e) {
        e.preventDefault();
        emit('dpc:media', { surface: 'choice_photo' });
        var gal = document.querySelector('product-gallery, .product-gallery');
        if (gal) gal.scrollIntoView({ block: 'start', behavior: reduce && reduce.matches ? 'auto' : 'smooth' });
      });
      size();
      update(false);
    })();

    // ---- The gallery follows a colour on the tap ----
    // Martin 2026-10-23 (Test, desktop wifi): the photo was slow on every colour tap, measured 1.1-1.2 s: the gallery
    // only moved with Prestige's switch, which waits for the pause (PAUSE_MS), and then fetched the slide (the
    // gallery's slides are lazy). As the wall builder does (#104 R12): a photographed colour row's slides are fetched
    // once the row opens, and a tap selects its slide at once. Prestige's own switch later selects the same slide.
    (function galleryColour() {
      if (!Object.keys(photoRows).length) return;
      function carousel() { var g = document.querySelector('product-gallery'); return g && g.carousel; }
      function pathOf(s) { try { return new URL(s, location.href).pathname; } catch (e) { return ''; } }
      function slideFor(car, src) {
        var want = pathOf(src), cells = (car && car.cells) || [];
        if (!want) return -1;
        for (var i = 0; i < cells.length; i++) {
          var im = cells[i].querySelector('img');
          if (im && pathOf(im.currentSrc || im.src) === want) return i;
        }
        return -1;
      }
      var pinFetched = {};
      var isSet = !!(data.set_photos && data.set_photos.length);
      function warm(name) {
        var spec = rowSpec(name), car = carousel();
        (spec && spec.values || []).forEach(function (val) {
          var src = photo(name, val.value);
          var i = slideFor(car, src), im = i >= 0 && car.cells[i].querySelector('img');
          if (im && im.loading === 'lazy') im.loading = 'eager';
          // The phone's pinned photo uses the data's own size of the same photo. A set's photos are not in its
          // gallery, so desktop fetches them too: the tap then shows one already in memory (Martin 2026-10-24: instant).
          if (src && (window.innerWidth <= 749 || isSet) && !pinFetched[src]) { pinFetched[src] = new Image(); pinFetched[src].src = src; }
        });
      }

      // #94 desktop: a wall set's colour photo is the shelf's own, not one of the set's slides, so it is laid over the
      // main gallery image (the set's room photo stays in the gallery underneath). Any tap on the gallery, or on the
      // photo itself, takes it away again.
      var view = null;
      function hideView() { if (view) view.hidden = true; }
      function showView(src, label) {
        var gal = document.querySelector('product-gallery');
        var list = gal && gal.querySelector('.product-gallery__image-list');
        var main = list && list.querySelector('.product-gallery__carousel');
        if (!main) return;
        if (!view) {
          view = document.createElement('button');
          view.type = 'button';
          view.className = 'dpc-bb-setview';
          view.setAttribute('aria-label', 'Back to the gallery');
          view.innerHTML = '<img alt="" decoding="sync"><span class="dpc-bb-setview__cap"></span>';
          list.appendChild(view);
          view.addEventListener('click', hideView);
          gal.addEventListener('click', function (e) { if (!view.contains(e.target)) hideView(); }, true);
        }
        var car = carousel();
        if (car && car.isScrollable) car.select(0, { instant: true });
        view.style.top = main.offsetTop + 'px';
        view.style.left = main.offsetLeft + 'px';
        view.style.width = main.offsetWidth + 'px';
        view.style.height = main.offsetHeight + 'px';
        view.querySelector('img').src = src;
        view.querySelector('span').textContent = label;
        view.hidden = false;
      }
      rows.forEach(function (r) {
        if (!browsable(r.name)) return;
        var el = rowEl(r.name);
        if (!el) return;
        if (el.open) warm(r.name);
        el.addEventListener('toggle', function () { if (el.open) warm(r.name); });
      });
      document.addEventListener('dpc:choice', function (e) {
        var d = e.detail || {};
        if (!browsable(d.rowName)) return;
        var car = carousel();
        var src = photo(d.rowName, d.value);
        var i = slideFor(car, src);
        if (i >= 0 && car.isScrollable) car.select(i, { instant: true });
        // Not on 'prefill': those are the set's own defaults registered at page load, and the page must open on the
        // set's first photo (Martin 2026-10-24). Taps, ideas and early taps still show the shelf photo.
        else if (i < 0 && isSet && src && window.innerWidth > 749 && d.source !== 'prefill') showView(src, shownLabel(d.rowName, d.value));
      });
    })();

    // Sticky Add to basket bar: hidden while the buy box is on screen (its own button is right there), back once it
    // is scrolled past. Martin 2026-10-21, v2 pages only; on the old layout his 2026-05-12 rule (once shown, the bar
    // stays) still holds. A body class, so it survives Prestige re-rendering the bar on variant change.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('dpc-bb-choosing', entries[0].isIntersecting);
      }).observe(box);
    }

    // Desktop: pin the gallery beside the buy box only when the window shows it whole (the Alto rule, T-562), in the
    // two-column layout (>= 1000px). The below-gallery content renders after .product, so it is never covered.
    (function galleryPin() {
      var gal = document.querySelector('.product > .product-gallery');
      if (!gal) return;
      function check() {
        var hh = hdr ? hdr.offsetHeight : 0;
        var fits = window.innerWidth >= 1000 && gal.offsetHeight + hh + 20 <= window.innerHeight;
        document.body.classList.toggle('dpc-bb-gallery-pin', fits);
      }
      window.addEventListener('resize', check, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(gal);
      check();
    })();

    analytics(box, data);

    // Landing state: rows the server pre-filled (a ?variant= link) count as choices with source "prefill". An answer
    // that differs from the server's was tapped before this script was ready: it goes to Prestige's form like a tap.
    rows.forEach(function (r) {
      var c = rowEl(r.name) && rowEl(r.name).querySelector('.dpc-bb-input:checked');
      if (c) choose(r.name, c.value, c.value === (r.selected || '') ? 'prefill' : 'early');
    });
    if (sameAll && followers.length) {
      // On when every follower already equals shelf 1 (the set defaults are Beige/Beige). An early tap that made them
      // differ starts unlinked: what is on screen is what is ordered. No mirroring happens at load.
      setLinked(followers.every(function (f) { return state[f] === state.shelf_1_upper_fabric; }));
      sameAll.hidden = false;
    }
    refresh();
    box.dataset.bbReady = '1';

    // A tap held by the snippet's guard before this script was ready (F10): replayed once the form holds the variant
    // the answers make (Prestige moves the form's id a moment after the native radio changes).
    var held = window.DPCBuyboxHeld;
    if (held) {
      window.DPCBuyboxHeld = null;
      var tries = 0;
      (function replay() {
        var v = currentVariant();
        var id = cartForm() && cartForm().querySelector('input[name="id"]');
        // Never posted while the form still holds another variant: after 5s the tap is dropped instead.
        if (openList().length || !v || (id && +id.value === v.id)) addFrom(held);
        else if (tries++ < 50) setTimeout(replay, 100);
      })();
    }
  }

  // ---- Task 6: GA4 + Clarity, from the dpc:* events above ----
  // ANALYTICS-PLAN 3b and docs/analytics/ga4-conventions.md. Sent through gtag(), so Consent Mode applies as for every
  // other event (never Measurement Protocol). No choice VALUES are sent: the order data stays in Shopify.
  function analytics(box, data) {
    var core = {
      item_id: String(data.product_id || ''),
      product_handle: data.handle || '',
      vendor: data.vendor || '',
      device: window.DPCBuybox.deviceOf(window.innerWidth),
      pdp_layout: 'v2',
      prefill: /[?&]variant=\d/.test(location.search)
    };
    function send(name, params) {
      setTimeout(function () {
        try {
          if (typeof gtag !== 'function') return;
          var p = {};
          Object.keys(core).forEach(function (k) { p[k] = core[k]; });
          Object.keys(params || {}).forEach(function (k) { p[k] = params[k]; });
          gtag('event', name, p);
        } catch (e) { /* analytics never breaks the page */ }
      }, 0);
    }
    function clarity() {
      try { if (typeof window.clarity === 'function') window.clarity.apply(window, arguments); } catch (e) { /* ignore */ }
    }
    // select_options_open keeps its T-826 name: once per page view, at the shopper's first touch of any choice.
    var touched = false;
    function touch(trigger) {
      if (touched) return;
      touched = true;
      send('select_options_open', { open_trigger: trigger });
    }
    function on(type, fn) {
      document.addEventListener(type, function (e) { try { fn(e.detail || {}); } catch (err) { /* ignore */ } });
    }

    clarity('set', 'dpc_surface', 'pdp_v2');
    box.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.dpc-bb-row > summary')) touch('row');
    });
    var sent = {};
    on('dpc:choice', function (d) {
      if (d.source === 'tap' || d.source === 'same') touch('row');
      if (sent[d.rowName]) return;   // re-changes are not re-sent (Clarity shows the dithering)
      sent[d.rowName] = true;
      send('pdp_choice', { row_index: d.rowIndex, row_name: d.rowName, source: d.source === 'same' ? 'tap' : d.source });
    });
    on('dpc:sameall', function (d) { if (!d.on) { send('pdp_set_split', {}); clarity('event', 'pdp_set_split'); } });
    on('dpc:preset', function () {
      touch('preset');
      send('pdp_preset_apply', {});
      clarity('event', 'pdp_preset_apply');
    });
    on('dpc:complete', function (d) {
      send('pdp_choices_complete', { source_mix: d.sourceMix, rows_required: d.rowsRequired });
    });
    on('dpc:blocked', function (d) {
      touch('cta_missing');
      send('pdp_cta_blocked', { choices_left: d.choicesLeft, first_open: d.firstOpen, routed_to: d.routedTo,
        location: d.location === 'bar' ? 'sticky' : 'inline' });
      clarity('event', 'pdp_cta_blocked');
    });
    on('dpc:addon', function (d) {
      send('pdp_addon', { addon: 'cat_wall_step', action: d.action, qty: d.qty });
    });
    on('dpc:media', function (d) {
      if (d.surface === 'choice_photo') touch('photo_panel');
      send('pdp_media_open', { surface: d.surface });
    });
    // The gallery's own zoom (lightbox) and videos, on Prestige's markup.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product-gallery [aria-controls*="zoom"], .product-gallery__zoom-button, product-gallery [is="open-lightbox-button"]')) send('pdp_media_open', { surface: 'lightbox' });
    }, true);
    document.addEventListener('play', function (e) {
      if (e.target.closest && e.target.closest('product-gallery, .product-gallery')) send('pdp_media_open', { surface: 'video' });
    }, true);
    on('dpc:addresult', function (d) {
      send('pdp_add_result', { result: d.result, lines: d.lines, has_addon: !!d.hasAddon, preset_used: !!d.presetUsed,
        value: Math.round(d.value || 0) / 100, currency: 'GBP' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
